import { SharePointService, UpdateService } from 'sp-office365-framework';
import { IList } from '@pnp/sp/presets/all';

export class UpdateToVersion1061Component {
    constructor(
        private sharePointService: SharePointService,
        private _updateService: UpdateService
    ) {}

    run() {
        const promise = new Promise<void>(async (resolve, reject) => {
            const taskTemplates = this.sharePointService.web.lists.getByTitle(
                'Aufgabenvorlagen'
            );
            let taskTemplateDocsList: IList;

            const promises = [
                // Add List Aufgabenvorlagendokumente
                await this._updateService.addList(
                    'Aufgabenvorlagendokumente',
                    '',
                    101,
                    {
                        EnableVersioning: true,
                    }
                ),
                // Get List Aufgabenvorlagendokumente
                await new Promise<void>((resolve) => {
                    taskTemplateDocsList = this.sharePointService.web.lists.getByTitle(
                        'Aufgabenvorlagendokumente'
                    );
                    resolve();
                }),
                // Add Field Aufgabenvorlage to List Aufgabenvorlagendokumente
                await new Promise<void>((resolve, reject) => {
                    taskTemplates
                        .select('Id')()
                        .then(
                            (taskTemplatesProps) => {
                                this._updateService
                                    .runFunctionIfFieldNotExists(
                                        taskTemplateDocsList,
                                        'Aufgabenvorlage',
                                        () => {
                                            const promise = new Promise<void>(
                                                (resolve2, reject2) => {
                                                    // taskTemplateDocsList.fields
                                                    //     .addLookup(
                                                    //         'Aufgabenvorlage',
                                                    //         taskTemplatesProps.Id.toString(),
                                                    //         'Title'
                                                    //     )
                                                    //     .then(
                                                    //         () => {
                                                    //             resolve2();
                                                    //         },
                                                    //         (error) => {
                                                    //             reject2(error);
                                                    //         }
                                                    //     );
                                                }
                                            );
                                            return promise;
                                        }
                                    )
                                    .then(
                                        () => {
                                            resolve();
                                        },
                                        (error) => {
                                            reject(error);
                                        }
                                    );
                            },
                            (error) => {
                                reject(error);
                            }
                        );
                }),
            ];

            Promise.all(promises).then(
                () => resolve(),
                (error) => {
                    reject(error);
                }
            );
        });
        return promise;
    }
}
